import * as React from "react"
import {SvgFunction} from "@web-libs/ui/svgs/types";
const CalendarIcon: SvgFunction = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 32}
        height={props.height ?? 32}
        viewBox={"0 0 32 32"}
    >
        <path
            fill={props.fill}
            d="M32 9.333v16A6.674 6.674 0 0 1 25.333 32H6.667A6.674 6.674 0 0 1 0 25.333v-16a6.674 6.674 0 0 1 6.667-6.666H8V1.333a1.333 1.333 0 1 1 2.667 0v1.334h10.666V1.333a1.333 1.333 0 1 1 2.667 0v1.334h1.333A6.674 6.674 0 0 1 32 9.333Zm-29.333 0v1.334h26.666V9.333c0-2.205-1.794-4-4-4H6.667c-2.206 0-4 1.795-4 4Zm26.666 16v-12H2.667v12c0 2.206 1.794 4 4 4h18.666c2.206 0 4-1.794 4-4Z"
        />
    </svg>
)
export default CalendarIcon
